<template>
  <div class="mt-6 pb-12 text-center text-[13px]">
    <p class="text-black dark:text-white"> Не нашли ответа на свой вопрос?</p>
    <a href="https://t.me/geekstore_support" target="_blank"
      class="mt-2 flex gap-x-2 items-center justify-center w-fit mx-auto text-blue" @click="trackSupportClick">
      <Icon width="16" height="16" />
      Напишите нам в поддержку
      <Icon width="16" height="16" />
    </a>
  </div>

</template>

<script setup>
import Icon from "@/assets/icons/life-ring.svg";
import { useYandexMetrika } from 'yandex-metrika-vue3'

const yandexMetrika = useYandexMetrika()

const trackSupportClick = () => {
  yandexMetrika.reachGoal('SUPPORT_CLICK');
}

</script>

<style></style>
